module.exports = "/_next/static/images/8d4e0d2340bbe62bf93f836bdf84702c-doc.svg.webp";